const SUPPLIES = ['supplies', 'supplies/:id'];

export default SUPPLIES;
